import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import JsonLd from "@/components/seo/JsonLd";
import { organizationLd } from "@/data/schema";
import Header from "@/components/layout/Header";
import Footer from "@/components/layout/Footer";
import ScrollToTop from "@/components/layout/ScrollToTop";
import Analytics from "@/components/analytics/Analytics";
import CookieBanner from "@/components/analytics/CookieBanner";
import Home from "@/pages/Home";
import FeaturesPage from "@/pages/Features";
import PricingPage from "@/pages/Pricing";
import AIPage from "@/pages/AI";
import DownloadPage from "@/pages/Download";
import BlogIndex from "@/pages/BlogIndex";
import BlogPost from "@/pages/BlogPost";
import PrivacyPage from "@/pages/Privacy";
import TermsPage from "@/pages/Terms";
import NotFound from "@/pages/NotFound";
import Admin from "@/pages/Admin";

function App() {
    return (
        <HelmetProvider>
            <BrowserRouter>
                <JsonLd data={organizationLd} />
                <ScrollToTop />
                <Analytics />
                <div className="flex min-h-screen flex-col">
                    <Header />
                    <main className="flex-1">
                        <Routes>
                            <Route path="/" element={<Home />} />
                            <Route path="/features" element={<FeaturesPage />} />
                            <Route path="/pricing" element={<PricingPage />} />
                            <Route path="/ai" element={<AIPage />} />
                            <Route path="/download" element={<DownloadPage />} />
                            <Route path="/blog" element={<BlogIndex />} />
                            <Route path="/blog/:slug" element={<BlogPost />} />
                            <Route path="/polityka-prywatnosci" element={<PrivacyPage />} />
                            <Route path="/regulamin" element={<TermsPage />} />
                            <Route path="/kokpit-a91f3d" element={<Admin />} />
                            <Route path="*" element={<NotFound />} />
                        </Routes>
                    </main>
                    <Footer />
                </div>
                <CookieBanner />
            </BrowserRouter>
        </HelmetProvider>
    );
}

export default App;
